export function initGTM(containerId, dataLayerName = 'dataLayer') {
  if (typeof window === 'undefined') return;
  if (!containerId) return;
  if (window.__gtmInitialized) return;

  window[dataLayerName] = window[dataLayerName] || [];
  window[dataLayerName].push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}${dataLayerName !== 'dataLayer' ? `&l=${encodeURIComponent(dataLayerName)}` : ''}`;
  document.head.appendChild(script);

  window.__gtmInitialized = true;
}

export function setupDeferredGTM({
  containerId,
  dataLayerName = 'dataLayer',
  enabled = true,
} = {}) {
  if (!enabled || !containerId || typeof window === 'undefined') {
    return () => {};
  }

  let started = false;
  const listeners = [
    ['pointerdown', { once: true, passive: true }],
    ['touchstart', { once: true, passive: true }],
    ['keydown', { once: true }],
    ['scroll', { once: true, passive: true }],
  ];

  const startAnalytics = () => {
    if (started) return;
    started = true;
    initGTM(containerId, dataLayerName);
  };

  const startOnInteraction = () => startAnalytics();

  listeners.forEach(([eventName, options]) => {
    window.addEventListener(eventName, startOnInteraction, options);
  });

  return () => {
    window.removeEventListener('pointerdown', startOnInteraction);
    window.removeEventListener('touchstart', startOnInteraction);
    window.removeEventListener('keydown', startOnInteraction);
    window.removeEventListener('scroll', startOnInteraction);
  };
}
